export function formatBadgeNumber(count: number, limit?: number, round = false): string {
  // Handle the case where rounding is enabled
  if (round) {
    if (count >= 1000000) {
      const rounded = (count / 1000000).toFixed(1);
      return rounded.endsWith('.0') ? `${Math.round(count / 1000000)}m` : `${rounded}m`;
    } else if (count >= 1000) {
      const rounded = (count / 1000).toFixed(1);
      return rounded.endsWith('.0') ? `${Math.round(count / 1000)}k` : `${rounded}k`;
    }
  }

  // Handle the case where count exceeds the limit and rounding is not required
  if (limit !== undefined && count > limit) {
    return `${limit}+`;
  }

  // Return the count as a string if it's below the limit or if rounding is not enabled
  return count.toString();
}
